var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.649 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,28.226a4.167,4.167,0,0,1-2.917-1.208,4.083,4.083,0,0,1,0-5.833l3-3a4.083,4.083,0,0,1,5.833,0,.833.833,0,0,1-1.167,1.167,2.5,2.5,0,0,0-3.5,0l-3,3a2.475,2.475,0,1,0,3.5,3.5l1.875-1.958a.833.833,0,0,1,1.167,1.167l-1.875,1.958A4.167,4.167,0,0,1,8.1,28.226Z",
    transform: "translate(-3.959 -11.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.583,15.25a4.167,4.167,0,0,1-2.917-1.208.833.833,0,0,1,1.167-1.167,2.5,2.5,0,0,0,3.5,0l3-3a2.475,2.475,0,0,0-3.5-3.5L21.958,8.333a.833.833,0,0,1-1.167-1.167l1.875-1.958A4.125,4.125,0,1,1,28.5,11.042l-3,3A4.167,4.167,0,0,1,22.583,15.25Z",
    transform: "translate(-13.024 -4)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.df79bad469fc63c68d5c5b21c2d4ea66.svg";
export { ForwardRef as ReactComponent };